var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "wrap-text", staticStyle: { margin: "0", padding: "0" } },
    [
      _vm.toastReportItem &&
      _vm.toastReportItem.requestId &&
      _vm.toastReportItem.status === _vm.REPORT_TOAST_STATUS.LOADING &&
      !_vm.isShowCreateBriefing
        ? _c(
            "div",
            {
              key: _vm.toastReportItem && _vm.toastReportItem.requestId,
              staticClass:
                "toast fade show go-toast go-toast-alert go-toast-loading wrap-text",
              staticStyle: {
                "margin-bottom": "10px",
                display: "block",
                position: "relative",
              },
              attrs: { "aria-live": "assertive", "aria-atomic": "true" },
            },
            [
              _c("div", { staticClass: "toast-body" }, [
                _c("div", { staticClass: "go-icon-wrap" }, [
                  _c(
                    "div",
                    { staticClass: "go-animation go-loader-animation" },
                    [
                      _c(
                        "svg",
                        {
                          staticClass: "go-loader-svg",
                          attrs: { viewBox: "0 0 50 50" },
                        },
                        [
                          _c("circle", {
                            staticClass: "loader-circle bg",
                            attrs: { cx: "25", cy: "25", r: "23" },
                          }),
                          _vm._v(" "),
                          _c("circle", {
                            staticClass: "loader-circle animate",
                            attrs: { cx: "25", cy: "25", r: "23" },
                          }),
                        ]
                      ),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "go-text-wrap" }, [
                  _vm.toastReportItem.type ===
                  _vm.LOADING_DATA_TYPE.JOURNALIST_NOTE.toString()
                    ? _c("strong", { staticClass: "wrap-text" }, [
                        _vm._v(_vm._s(_vm.$t("cdToast.t1"))),
                      ])
                    : _vm.toastReportItem.type ===
                      _vm.LOADING_DATA_TYPE.SOCIAL_MEDIA_POSTING.toString()
                    ? _c("strong", { staticClass: "wrap-text" }, [
                        _vm._v(_vm._s(_vm.$t("cdToast.t2"))),
                      ])
                    : _vm.toastReportItem.type ===
                      _vm.LOADING_DATA_TYPE.PODCAST.toString()
                    ? _c("strong", { staticClass: "wrap-text" }, [
                        _vm._v(_vm._s(_vm.$t("cdToast.t3"))),
                      ])
                    : _vm.toastReportItem.type ===
                        _vm.LOADING_DATA_TYPE.REPORT.toString() &&
                      _vm.toastReportItem.bpId
                    ? _c("strong", { staticClass: "wrap-text" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "toast-report.loading-toast.titleBriefingAgent"
                            )
                          )
                        ),
                      ])
                    : _c("strong", { staticClass: "wrap-text" }, [
                        _vm._v(_vm._s(_vm.generateReportTitle)),
                      ]),
                  _vm._v(" "),
                  _c("ul", { staticClass: "go-info-list" }, [
                    _vm.toastReportItem.type ===
                    _vm.LOADING_DATA_TYPE.PODCAST.toString()
                      ? _c("li", { staticClass: "go-list-item wrap-text" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm.$t(
                                  "toast-report.loading-toast.infoText.textPodcast"
                                )
                              ) +
                              "\n          "
                          ),
                        ])
                      : _vm.toastReportItem.type ===
                          _vm.LOADING_DATA_TYPE.REPORT.toString() &&
                        !_vm.toastReportItem.bpId &&
                        _vm.reportTypesResult.includes("INDEPTH_DAILY")
                      ? _c("li", { staticClass: "go-list-item wrap-text" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm.$t(
                                  "toast-report.loading-toast.infoText.textInDepth"
                                )
                              ) +
                              "\n          "
                          ),
                        ])
                      : _vm.toastReportItem.type ===
                          _vm.LOADING_DATA_TYPE.REPORT.toString() &&
                        _vm.toastReportItem.bpId
                      ? _c("li", { staticClass: "go-list-item wrap-text" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.generatebriefingText) +
                              "\n          "
                          ),
                        ])
                      : _c("li", { staticClass: "go-list-item wrap-text" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "toast-report.loading-toast.infoText.text1"
                              )
                            )
                          ),
                        ]),
                    _vm._v(" "),
                    _c("li", { staticClass: "go-list-item wrap-text" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t("toast-report.loading-toast.infoText.text2")
                        )
                      ),
                    ]),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn go-btn-icon close",
                  attrs: {
                    id: _vm.toastReportItem.requestId + "_buttonCloseToast",
                    type: "button",
                    "data-dismiss": "toast",
                  },
                  on: { click: _vm.handleRemoveToastReportDataByRequestId },
                },
                [_c("i", { staticClass: "go-icon-20 go-icon-close" })]
              ),
            ]
          )
        : _vm.toastReportItem &&
          _vm.toastReportItem.requestId &&
          _vm.toastReportItem.status === _vm.REPORT_TOAST_STATUS.SUCCESS &&
          _vm.toastReportItem.bpId &&
          _vm.toastReportItem.reportTypesResultForBriefing.length > 0
        ? _c(
            "div",
            {
              key: _vm.toastReportItem && _vm.toastReportItem.requestId,
              staticClass:
                "toast fade show go-toast go-toast-alert go-toast-success wrap-text",
              staticStyle: {
                "margin-bottom": "10px",
                display: "block",
                position: "relative",
              },
              attrs: { "aria-live": "assertive", "aria-atomic": "true" },
            },
            [
              _c("div", { staticClass: "toast-body" }, [
                _c("div", { staticClass: "go-icon-wrap" }, [
                  _c(
                    "div",
                    { staticClass: "go-animation go-success-animation" },
                    [
                      _c(
                        "svg",
                        {
                          staticClass: "go-success-svg",
                          attrs: { viewBox: "0 0 50 50" },
                        },
                        [
                          _c("circle", {
                            staticClass: "success-circle",
                            attrs: {
                              cx: "25",
                              cy: "25",
                              r: "24",
                              fill: "none",
                            },
                          }),
                          _vm._v(" "),
                          _c("path", {
                            staticClass: "success-check",
                            attrs: {
                              fill: "none",
                              d: "M14.1 27.2l7.1 7.2 16.7-16.8",
                            },
                          }),
                        ]
                      ),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "go-text-wrap" }, [
                  _c("strong", { staticClass: "wrap-text" }, [
                    _vm._v(_vm._s(_vm.$t("cdToast.t4"))),
                  ]),
                  _vm._v(" "),
                  _c("ul", { staticClass: "go-info-list" }, [
                    _c("li", { staticClass: "go-list-item wrap-text" }, [
                      _vm._v(_vm._s(_vm.$t("cdToast.t6a"))),
                    ]),
                    _vm._v(" "),
                    _c("li", { staticClass: "go-list-item wrap-text" }, [
                      _vm._v(_vm._s(_vm.briefingCreatingText)),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "go-btn-area" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn go-btn-default",
                        attrs: { type: "button" },
                        on: { click: _vm.handleOpenReportDetail },
                      },
                      [
                        _c("em", { staticClass: "go-success wrap-text" }, [
                          _vm._v(_vm._s(_vm.$t("cdToast.t7"))),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn go-btn-default wrap-text",
                        attrs: { type: "button" },
                        on: { click: _vm.handleGoToBriefingPage },
                      },
                      [_vm._v(_vm._s(_vm.$t("cdToast.t8")))]
                    ),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn go-btn-icon close",
                  attrs: {
                    id: _vm.toastReportItem.requestId + "_buttonCloseToast",
                    type: "button",
                    "data-dismiss": "toast",
                  },
                  on: { click: _vm.handleRemoveToastReportDataByRequestId },
                },
                [_c("i", { staticClass: "go-icon-20 go-icon-close" })]
              ),
            ]
          )
        : _vm.toastReportItem &&
          _vm.toastReportItem.requestId &&
          _vm.toastReportItem.status === _vm.REPORT_TOAST_STATUS.SUCCESS
        ? _c(
            "div",
            {
              key: _vm.toastReportItem && _vm.toastReportItem.requestId,
              staticClass:
                "toast fade show go-toast go-toast-alert go-toast-success wrap-text",
              staticStyle: {
                "margin-bottom": "10px",
                display: "block",
                position: "relative",
              },
              attrs: { "aria-live": "assertive", "aria-atomic": "true" },
            },
            [
              _c("div", { staticClass: "toast-body" }, [
                _c("div", { staticClass: "go-icon-wrap" }, [
                  _c(
                    "div",
                    { staticClass: "go-animation go-success-animation" },
                    [
                      _c(
                        "svg",
                        {
                          staticClass: "go-success-svg",
                          attrs: { viewBox: "0 0 50 50" },
                        },
                        [
                          _c("circle", {
                            staticClass: "success-circle",
                            attrs: {
                              cx: "25",
                              cy: "25",
                              r: "24",
                              fill: "none",
                            },
                          }),
                          _vm._v(" "),
                          _c("path", {
                            staticClass: "success-check",
                            attrs: {
                              fill: "none",
                              d: "M14.1 27.2l7.1 7.2 16.7-16.8",
                            },
                          }),
                        ]
                      ),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "go-text-wrap" },
                  [
                    _vm.toastReportItem.type ===
                    _vm.LOADING_DATA_TYPE.JOURNALIST_NOTE.toString()
                      ? [
                          _c("strong", { staticClass: "wrap-text" }, [
                            _vm._v(_vm._s(_vm.$t("cdToast.t9"))),
                          ]),
                          _vm._v(" "),
                          _c("ul", { staticClass: "go-info-list" }, [
                            _c(
                              "li",
                              { staticClass: "go-list-item wrap-text" },
                              [_vm._v(_vm._s(_vm.$t("cdToast.t10")))]
                            ),
                            _vm._v(" "),
                            _c(
                              "li",
                              { staticClass: "go-list-item wrap-text" },
                              [_vm._v(_vm._s(_vm.$t("cdToast.t6")))]
                            ),
                          ]),
                        ]
                      : _vm.toastReportItem.type ===
                        _vm.LOADING_DATA_TYPE.SOCIAL_MEDIA_POSTING.toString()
                      ? [
                          _c("strong", { staticClass: "wrap-text" }, [
                            _vm._v(_vm._s(_vm.$t("cdToast.t11"))),
                          ]),
                          _vm._v(" "),
                          _c("ul", { staticClass: "go-info-list" }, [
                            _c(
                              "li",
                              { staticClass: "go-list-item wrap-text" },
                              [_vm._v(_vm._s(_vm.$t("cdToast.t12")))]
                            ),
                            _vm._v(" "),
                            _c(
                              "li",
                              { staticClass: "go-list-item wrap-text" },
                              [_vm._v(_vm._s(_vm.$t("cdToast.t6")))]
                            ),
                          ]),
                        ]
                      : _vm.toastReportItem.type ===
                        _vm.LOADING_DATA_TYPE.PODCAST.toString()
                      ? [
                          _c("strong", { staticClass: "wrap-text" }, [
                            _vm._v(_vm._s(_vm.$t("cdToast.t13"))),
                          ]),
                          _vm._v(" "),
                          _c("ul", { staticClass: "go-info-list" }, [
                            _c(
                              "li",
                              { staticClass: "go-list-item wrap-text" },
                              [_vm._v(_vm._s(_vm.$t("cdToast.t14")))]
                            ),
                            _vm._v(" "),
                            _c(
                              "li",
                              { staticClass: "go-list-item wrap-text" },
                              [_vm._v(_vm._s(_vm.$t("cdToast.t15")))]
                            ),
                          ]),
                        ]
                      : [
                          _c("strong", { staticClass: "wrap-text" }, [
                            _vm._v(_vm._s(_vm.reportCreatingText)),
                          ]),
                          _vm._v(" "),
                          _c("ul", { staticClass: "go-info-list" }, [
                            _c(
                              "li",
                              { staticClass: "go-list-item wrap-text" },
                              [_vm._v(_vm._s(_vm.generatedReportText))]
                            ),
                            _vm._v(" "),
                            _c(
                              "li",
                              { staticClass: "go-list-item wrap-text" },
                              [_vm._v(_vm._s(_vm.$t("cdToast.t6")))]
                            ),
                          ]),
                        ],
                    _vm._v(" "),
                    _c("div", { staticClass: "go-btn-area" }, [
                      _vm.toastReportItem.type !==
                      _vm.LOADING_DATA_TYPE.PODCAST.toString()
                        ? _c(
                            "button",
                            {
                              staticClass: "btn go-btn-default",
                              attrs: { type: "button" },
                              on: { click: _vm.handleOpenReportDetail },
                            },
                            [
                              _c(
                                "em",
                                { staticClass: "go-success wrap-text" },
                                [_vm._v(_vm._s(_vm.$t("cdToast.t7")))]
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "btn go-btn-default wrap-text",
                          attrs: { type: "button" },
                          on: {
                            click: function ($event) {
                              return _vm.handleGoToPage(
                                _vm.toastReportItem.type
                              )
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$t("cdToast.t17")) +
                              "\n          "
                          ),
                        ]
                      ),
                    ]),
                  ],
                  2
                ),
              ]),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn go-btn-icon close",
                  staticStyle: {
                    background: "transparent",
                    border: "none",
                    cursor: "pointer",
                  },
                  attrs: {
                    id: _vm.toastReportItem.requestId + "_buttonCloseToast",
                    type: "button",
                    "data-dismiss": "toast",
                  },
                  on: { click: _vm.handleRemoveToastReportDataByRequestId },
                },
                [_c("i", { staticClass: "go-icon-20 go-icon-close" })]
              ),
            ]
          )
        : _vm.toastReportItem &&
          _vm.toastReportItem.requestId &&
          _vm.toastReportItem.status === _vm.REPORT_TOAST_STATUS.FAILED &&
          _vm.toastReportItem.statusCode ===
            _vm.REPORT_TOAST_STATUS_CODE.NOT_ENOUGH_REFERENCES
        ? _c(
            "div",
            {
              key: _vm.toastReportItem && _vm.toastReportItem.requestId,
              staticClass:
                "toast fade show go-toast go-toast-alert go-toast-warning wrap-text",
              staticStyle: {
                "margin-bottom": "10px",
                display: "block",
                position: "relative",
              },
              attrs: { "aria-live": "assertive", "aria-atomic": "true" },
            },
            [
              _c("div", { staticClass: "toast-body" }, [
                _vm._m(0),
                _vm._v(" "),
                _c("div", { staticClass: "go-text-wrap" }, [
                  _c("strong", { staticClass: "wrap-text" }, [
                    _vm._v(
                      _vm._s(
                        _vm.$t("toast-report.failed-toast.common.notComplete")
                      )
                    ),
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "wrap-text" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _vm.$t(
                            "toast-report.failed-toast.notEnoughReferences.text1"
                          )
                        )
                    ),
                    _c("br"),
                    _vm._v(
                      _vm._s(
                        _vm.$t(
                          "toast-report.failed-toast.notEnoughReferences.text2"
                        )
                      ) + "\n        "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "go-btn-area" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn go-btn-default wrap-text",
                        attrs: { type: "button" },
                        on: {
                          click: function ($event) {
                            return _vm.handleGoToPage(_vm.toastReportItem.type)
                          },
                        },
                      },
                      [
                        _vm.toastReportItem.type ===
                        _vm.LOADING_DATA_TYPE.JOURNALIST_NOTE.toString()
                          ? [_vm._v(_vm._s(_vm.$t("cdToast.t18")))]
                          : _vm.toastReportItem.type ===
                            _vm.LOADING_DATA_TYPE.SOCIAL_MEDIA_POSTING.toString()
                          ? [_vm._v(_vm._s(_vm.$t("cdToast.t19")))]
                          : _vm.toastReportItem.type ===
                            _vm.LOADING_DATA_TYPE.PODCAST.toString()
                          ? [_vm._v(_vm._s(_vm.$t("cdToast.t20")))]
                          : [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "toast-report.failed-toast.common.goToMyReport"
                                  )
                                )
                              ),
                            ],
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn go-btn-default wrap-text",
                        attrs: { type: "button" },
                        on: {
                          click: _vm.handleRemoveToastReportDataByRequestId,
                        },
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm.$t(
                                "toast-report.failed-toast.common.cancelCreation"
                              )
                            ) +
                            "\n          "
                        ),
                      ]
                    ),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn go-btn-icon close",
                  staticStyle: {
                    background: "transparent",
                    border: "none",
                    cursor: "pointer",
                  },
                  attrs: {
                    id: _vm.toastReportItem.requestId + "_buttonCloseToast",
                    type: "button",
                    "data-dismiss": "toast",
                  },
                  on: { click: _vm.handleRemoveToastReportDataByRequestId },
                },
                [_c("i", { staticClass: "go-icon-20 go-icon-close" })]
              ),
            ]
          )
        : _vm.toastReportItem &&
          _vm.toastReportItem.requestId &&
          _vm.toastReportItem.status === _vm.REPORT_TOAST_STATUS.FAILED &&
          _vm.toastReportItem.statusCode ===
            _vm.REPORT_TOAST_STATUS_CODE.OVER_REFERENCES
        ? _c(
            "div",
            {
              key: _vm.toastReportItem && _vm.toastReportItem.requestId,
              staticClass:
                "toast fade show go-toast go-toast-alert go-toast-warning wrap-text",
              staticStyle: {
                "margin-bottom": "10px",
                display: "block",
                position: "relative",
              },
              attrs: { "aria-live": "assertive", "aria-atomic": "true" },
            },
            [
              _c("div", { staticClass: "toast-body" }, [
                _vm._m(1),
                _vm._v(" "),
                _c("div", { staticClass: "go-text-wrap" }, [
                  _c("strong", { staticClass: "wrap-text" }, [
                    _vm._v(
                      _vm._s(
                        _vm.$t("toast-report.failed-toast.common.notComplete")
                      )
                    ),
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "wrap-text" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _vm.$t(
                            "toast-report.failed-toast.overReferences.text1"
                          )
                        )
                    ),
                    _c("br"),
                    _vm._v(
                      _vm._s(
                        _vm.$t("toast-report.failed-toast.overReferences.text2")
                      ) + "\n        "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "go-btn-area" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn go-btn-default wrap-text",
                        attrs: { type: "button" },
                        on: {
                          click: function ($event) {
                            return _vm.handleGoToPage(_vm.toastReportItem.type)
                          },
                        },
                      },
                      [
                        _vm.toastReportItem.type ===
                        _vm.LOADING_DATA_TYPE.JOURNALIST_NOTE.toString()
                          ? [_vm._v(_vm._s(_vm.$t("cdToast.t18")))]
                          : _vm.toastReportItem.type ===
                            _vm.LOADING_DATA_TYPE.SOCIAL_MEDIA_POSTING.toString()
                          ? [_vm._v(_vm._s(_vm.$t("cdToast.t19")))]
                          : _vm.toastReportItem.type ===
                            _vm.LOADING_DATA_TYPE.PODCAST.toString()
                          ? [_vm._v(_vm._s(_vm.$t("cdToast.t20")))]
                          : [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "toast-report.failed-toast.common.goToMyReport"
                                  )
                                )
                              ),
                            ],
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn go-btn-default wrap-text",
                        attrs: { type: "button" },
                        on: {
                          click: _vm.handleRemoveToastReportDataByRequestId,
                        },
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm.$t(
                                "toast-report.failed-toast.common.cancelCreation"
                              )
                            ) +
                            "\n          "
                        ),
                      ]
                    ),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn go-btn-icon close",
                  staticStyle: {
                    background: "transparent",
                    border: "none",
                    cursor: "pointer",
                  },
                  attrs: {
                    id: _vm.toastReportItem.requestId + "_buttonCloseToast",
                    type: "button",
                    "data-dismiss": "toast",
                  },
                  on: { click: _vm.handleRemoveToastReportDataByRequestId },
                },
                [_c("i", { staticClass: "go-icon-20 go-icon-close" })]
              ),
            ]
          )
        : _vm.toastReportItem &&
          _vm.toastReportItem.requestId &&
          _vm.toastReportItem.status === _vm.REPORT_TOAST_STATUS.FAILED &&
          _vm.toastReportItem.statusCode ===
            _vm.REPORT_TOAST_STATUS_CODE.SYSTEM_ERROR
        ? _c(
            "div",
            {
              key: _vm.toastReportItem && _vm.toastReportItem.requestId,
              staticClass:
                "toast fade show go-toast go-toast-alert go-toast-warning wrap-text",
              staticStyle: {
                "margin-bottom": "10px",
                display: "block",
                position: "relative",
              },
              attrs: { "aria-live": "assertive", "aria-atomic": "true" },
            },
            [
              _c("div", { staticClass: "toast-body" }, [
                _vm._m(2),
                _vm._v(" "),
                _c("div", { staticClass: "go-text-wrap" }, [
                  _c("strong", { staticClass: "wrap-text" }, [
                    _vm._v(
                      _vm._s(
                        _vm.$t("toast-report.failed-toast.common.notComplete")
                      )
                    ),
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "wrap-text" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _vm.$t("toast-report.failed-toast.systemError.text1")
                        )
                    ),
                    _c("br"),
                    _vm._v(
                      _vm._s(
                        _vm.$t("toast-report.failed-toast.systemError.text2")
                      ) + "\n          "
                    ),
                    _c(
                      "a",
                      {
                        attrs: {
                          href: "mailto:contact@goover.ai",
                          target: "_blank",
                        },
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "toast-report.failed-toast.systemError.text3"
                            )
                          )
                        ),
                      ]
                    ),
                    _vm._v(
                      _vm._s(
                        _vm.$t("toast-report.failed-toast.systemError.text4")
                      ) + "\n        "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "go-btn-area" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn go-btn-default wrap-text",
                        attrs: { type: "button" },
                        on: {
                          click: function ($event) {
                            return _vm.handleGoToPage(_vm.toastReportItem.type)
                          },
                        },
                      },
                      [
                        _vm.toastReportItem.type ===
                        _vm.LOADING_DATA_TYPE.JOURNALIST_NOTE.toString()
                          ? [_vm._v(_vm._s(_vm.$t("cdToast.t18")))]
                          : _vm.toastReportItem.type ===
                            _vm.LOADING_DATA_TYPE.SOCIAL_MEDIA_POSTING.toString()
                          ? [_vm._v(_vm._s(_vm.$t("cdToast.t19")))]
                          : _vm.toastReportItem.type ===
                            _vm.LOADING_DATA_TYPE.PODCAST.toString()
                          ? [_vm._v(_vm._s(_vm.$t("cdToast.t20")))]
                          : [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "toast-report.failed-toast.common.goToMyReport"
                                  )
                                )
                              ),
                            ],
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: false,
                            expression: "false",
                          },
                        ],
                        staticClass: "btn go-btn-default wrap-text",
                        attrs: { disabled: "", type: "button" },
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm.$t("toast-report.failed-toast.common.retry")
                            ) +
                            "\n          "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn go-btn-default wrap-text",
                        attrs: { type: "button" },
                        on: {
                          click: _vm.handleRemoveToastReportDataByRequestId,
                        },
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm.$t(
                                "toast-report.failed-toast.common.cancelCreation"
                              )
                            ) +
                            "\n          "
                        ),
                      ]
                    ),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn go-btn-icon close",
                  staticStyle: {
                    background: "transparent",
                    border: "none",
                    cursor: "pointer",
                  },
                  attrs: {
                    id: _vm.toastReportItem.requestId + "_buttonCloseToast",
                    type: "button",
                    "data-dismiss": "toast",
                  },
                  on: { click: _vm.handleRemoveToastReportDataByRequestId },
                },
                [_c("i", { staticClass: "go-icon-20 go-icon-close" })]
              ),
            ]
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "go-icon-wrap" }, [
      _c("i", { staticClass: "go-icon-48 go-icon-alert-warning" }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "go-icon-wrap" }, [
      _c("i", { staticClass: "go-icon-48 go-icon-alert-warning" }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "go-icon-wrap" }, [
      _c("i", { staticClass: "go-icon-48 go-icon-alert-warning" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }